import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangeSliderLookupComponent } from './range-slider-lookup.component';
import { Ng5SliderModule } from 'ng5-slider';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng5SliderModule
  ],
  declarations: [RangeSliderLookupComponent],
  exports: [RangeSliderLookupComponent]
})
export class RangeSliderLookupModule { }
